import React, { useContext, useState, useRef, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { Table, Tbody, Td, Tfoot, Th, Thead, Tr, useSortableData } from '../../NecttosComp/Table/Table';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { geTcNumbers, getTcBatches } from '../../NecttosComp/APICaller/ApiServices';
import { OLoading } from '../../static/svg/icons';
import toast, { Toaster } from 'react-hot-toast';
import { NecttosContext } from '../../context/NecttosContext';
import Input2 from '../../NecttosComp/Input/Input2';
import { FaCog } from 'react-icons/fa';
import { useAllClasses } from '../../NecttosComp/APICaller/queryHooks';
import TCView2 from './TCView2';
import Instruction from '../../Documentation/Instruction';

const semesters = ['l Semester', 'll Semester', 'lll Semester', 'lV Semester', 'V Semester', 'Vl Semester', 'Vll Semester', 'Vlll Semester', 'lX Semester', 'X Semester'];
const reasons = ['Course Completed', 'Discontinued', 'College Transfer', 'Higher Studies'];
const exams = ['Not attended', 'l Semester', 'll Semester', 'lll Semester', 'lV Semester', 'V Semester', 'Vl Semester', 'Vll Semester', 'Vlll Semester', 'lX Semester', 'X Semester'];
const catogorys = ['GENERAL', 'OBC', 'OBC (H)', 'OEC', 'ST', 'SC'];
const columnsApprove = [
	{
		title: 'S.N.',
		keyName: 'slNo',
		width: '40px',
	},
	{
		title: 'TC Number',
		keyName: 'tcNumber',
		width: '100px',
	},
	{
		title: 'Admission No',
		keyName: 'admisionNo',
		width: '130px',
	},
	{
		title: 'action',
		keyName: 'action',
		width: '180px',
	},
	{
		title: 'Name',
		keyName: 'name',
		width: '250px',
	},
	{
		title: 'Class Name',
		keyName: 'className',
		key: 'className',
		width: '180px',
	},
	{
		title: 'Date of Admn',
		keyName: 'dateOfAdmission',
		width: '120px',
		type: 'date',
	},

	{
		title: 'Leaving Date',
		keyName: 'tcDate',
		width: '120px',
		type: 'date',
	},
];
const columnsRequests = [
	{
		title: 'S.N.',
		keyName: 'slNo',
		width: '40px',
	},
	{
		title: 'TC Number',
		keyName: 'tcNumber',
		width: '100px',
	},
	{
		title: 'Admission No',
		keyName: 'admisionNo',
		width: '130px',
	},
	{
		title: 'action',
		keyName: 'action',
		width: '200px',
	},
	{
		title: 'Name',
		keyName: 'name',
		width: '250px',
	},
	{
		title: 'Class Name',
		keyName: 'className',
		key: 'className',
		width: '180px',
	},
	{
		title: 'Date of Admn',
		keyName: 'dateOfAdmission',
		width: '120px',
		type: 'date',
	},

	{
		title: 'Applied Date',
		keyName: 'appliedOn',
		width: '120px',
		type: 'date',
	},
];
const fetchTcLists = async ({ printed, collegeId, filters, advancedSearch, listType, page, limit }) => {
	const instance = await getAxiosTokenInstance();

	const params = {
		collegeId,
		classId: filters?.classId,
		admnStartDate: filters?.admnDateStartNo,
		admnEndingDate: filters?.admnDateEndNo,
		startAdmNo: filters?.admissionNoStart,
		endAdmNo: filters?.admissionNoEnd,
		tcStartDate: filters?.tcStartDate,
		tcEndDate: filters?.tcEndDate,
		startTcNo: filters?.tcStartNo,
		endTcNo: filters?.tcEndNo,
		governBy: filters?.governBy,
		selectedBatch: filters?.batchId,
		searchQuery: advancedSearch,
		printed: printed,
		listType,
		page,
		limit,
	};

	const resp = await instance.get('/college/tc/getTCList', { params });

	if (resp.data.statusCode === 400) {
		throw new Error(resp.data.message || 'API Error');
	}

	return resp?.data;
};
const getUserList = async (collegeId) => {
	const instance = await getAxiosTokenInstance();
	const resp = await instance.get(`college/tc/getUsers?collegeId=${collegeId}&type=student`);
	return resp?.data;
};

const getClassByBatch = async ({ collegeId, filters }) => {
	try {
		const instance = await getAxiosTokenInstance();
		const { data } = await instance.get('/college/tc/getClassByBatch', {
			params: { collegeId, batch: filters?.batchId },
		});
		return data.list;
	} catch (error) {
		console.error(error);
	}
};

export const TransferCertificate = ({ onClose }) => {
	const [stages, setStages] = useState('base');
	const [section, setSection] = useState('All');
	const [modal, setModal] = useState('null');
	const [confirmation, setConfirmation] = useState({});
	const [advancedSearch, setAdvancedSearch] = useState('');
	const [sequenceCounter, setSequenceCounter] = useState({
		lastAidedTcNumber: '',
		lastAidedTcBatchNumber: '',
		lastSelfTcNumber: '',
		lastSelfTcBatchNumber: '',
		lastGovtTcBatchNumber: '',
		lastGovtTcNumber: '',
	});
	const [profile, setProfile] = useState(null);

	const { collegeId, college, profile: user } = useContext(NecttosContext);

	const ref = useRef();

	const [filters, setFilters] = useState({
		classId: '',
		batchId: '',
		admissionNoStart: '',
		admissionNoEnd: '',
		governBy: '',
		tcStartDate: '',
		tcEndDate: '',
		tcStartNo: '',
		tcEndNo: '',
		admnDateStartNo: '',
		admnDateEndNo: '',
		startDate: '',
		endingDate: '',
		printable: false,
		page: 1,
		limit: 25,
		refresh: false,
	});

	//loadings
	const [loading, setLoading] = useState(false);
	const [profileLoading, setProfileLoading] = useState(false);

	const { data: userList } = useQuery(['getUserListstudent', collegeId], () => getUserList(collegeId), {
		cacheTime: 60 * 30 * 1000,
		refetchOnWindowFocus: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
		staleTime: 25 * 60 * 1000,
		enabled: !!collegeId,
	});
	const { data: allClassdata } = useAllClasses({ needAll: true, classOnly: true });
	const { data: batches = [] } = useQuery('getBatches', getTcBatches({ collegeId }), { cacheTime: 60 * 600 * 1000, refetchOnMount: false, refetchOnWindowFocus: false, refetchInterval: false, refetchIntervalInBackground: false, staleTime: 25 * 60 * 1000 });
	const { data: seqData, isFetched: sequenceDataFetched, refetch: refetchSequenceData } = useQuery(['getSequence123'], geTcNumbers(collegeId), { enabled: !!collegeId });
	const { data: classDataByBatch } = useQuery(['getClassByBatch', filters?.batchId], () => getClassByBatch({ collegeId, filters }), { enabled: !!collegeId && !!filters?.batchId, refetchInterval: false, refetchOnMount: false, refetchIntervalInBackground: false });

	const {
		data: tcList = [],
		isLoading: isTcListLoading,
		isError,
		error,
		refetch: refetchTcList,
		isFetching,
	} = useQuery(
		['tc-list', collegeId, filters, section, filters?.page, filters?.limit, filters?.refresh],
		() =>
			fetchTcLists({
				collegeId,
				filters,
				advancedSearch,
				listType: section,
				page: filters?.page,
				limit: filters?.limit,
			}),
		{
			enabled: !!collegeId,
			refetchOnMount: false,
			refetchIntervalInBackground: false,
			refetchOnWindowFocus: false,
		},
	);

	useEffect(() => {
		if (seqData && sequenceDataFetched) {
			setSequenceCounter({
				lastAidedTcNumber: seqData?.lastAidedTcNumber || 0,
				lastAidedTcBatchNumber: seqData?.lastAidedTcBatchNumber || 0,
				lastSelfTcNumber: seqData?.lastSelfTcNumber || 0,
				lastSelfTcBatchNumber: seqData?.lastSelfTcBatchNumber || 0,
				lastGovtTcNumber: seqData?.lastGovtTcNumber || 0,
				lastGovtTcBatchNumber: seqData?.lastGovtTcBatchNumber || 0,
			});
		}
	}, [seqData, sequenceDataFetched]);

	const { tableItems, requestSort, getIcon } = useSortableData(tcList?.list || []);

	// api functions

	const deleteTC = async (data) => {
		try {
			await waitConformation('delete');
		} catch (error) {
			console.error('Error waiting for confirmation:', error);
			return;
		}
		setLoading(true);
		try {
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/tc/addToMessageTcCcRequestsNew', {
				collegeId,
				messageData: '',
				checkRole: '',
				action: 'delete',
				classId: '',
				departmentId: '',
				userId: data?._id,
			});
			if (resp.data.statusCode !== 200) {
				toast.error('Error deleting TC: API error');
			}
			toast.success('Deletion successful.');
		} catch (error) {
			console.error('Error deleting TC:', error);
			toast.error('Error deleting TC');
		} finally {
			setLoading(false);
			setSection('Requested');
			refetchTcList();
			refetchSequenceData();
		}
	};
	const aproveTcCc = async (data) => {
		try {
			await waitConformation('approve');
		} catch (error) {
			return;
		}
		setLoading(true);
		try {
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/tc/addToMessageTcCcRequestsNew', {
				collegeId,
				messageData: '',
				checkRole: '',
				action: 'aprove',
				classId: '',
				departmentId: '',
				userId: data?._id,
			});
			if (resp.data.statusCode !== 200) {
				toast.error('Error approving TC: API error');
			}
			toast.success('Approval successful.');
		} catch (error) {
			console.error('Error approving TC:', error);
			toast.error('Error approving TC:');
		} finally {
			setLoading(false);
			setSection('Approved');
			refetchTcList();
			refetchSequenceData();
		}
	};
	const oldTc = async () => {
		try {
			await waitConformation('submit');
		} catch (error) {
			return;
		}
		try {
			setLoading(true);
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/tc/instantTCNew', {
				type: 'student',
				collegeId: collegeId,
				fullName: profile?.name,
				phoneNumber: profile?.phoneNumber,
				dob: profile?.dob,
				classId: profile?.classId,
				dateOfAdmission: profile?.dateOfAdmission,
				category: profile?.category,
				admisionNo: profile?.admisionNo,
				dateOfLeaving: profile?.dateOfLeaving,
				hallTicketNo: profile?.hallTicketNo,
				requestLetter: profile?.requestLetter,
				reasonForLeaving: profile?.reasonForLeaving,
				exam: profile?.exam,
				leaving: profile?.leavingSem,
			});
			if (resp.statusCode !== 200) {
				setLoading(false);
				toast.error(resp?.message, 'Tc creation failed');
			} else {
				setLoading(false);
				toast.success('submitted');
			}
		} catch (error) {
			toast.error(error?.response?.data?.message);
			console.log({ error });
		} finally {
			setModal('null');
			setProfile({});
			setSection('Requested');
			refetchTcList();
			setLoading(false);
		}
	};

	const requestNewTC = async () => {
		try {
			await waitConformation('submit');
		} catch (error) {
			return;
		}
		try {
			setLoading(true);
			const instance = await getAxiosTokenInstance();
			const response = await instance.post('/college/tc/requestForTcCcNew', {
				collegeId,
				userId: profile?.userId || profile?._id,
				dateOfLeaving: profile?.dateOfLeaving,
				requestLetter: profile?.requestLetter,
				reasonForLeaving: profile?.reasonForLeaving,
				exam: profile?.exam,
				leaving: profile?.leavingSem,
				admisionNo: profile?.admisionNo,
				hallTicketNo: profile?.hallTicketNo,
				dob: profile?.dob,
				classId: profile?.classId,
				userfields: profile,
			});

			console.error({ response });
			if (response.status !== 200) {
				throw new Error(`Request failed with status ${response.status}: ${response.statusText}`);
			}

			setSection('Requested');
			setProfile({});
			refetchTcList();
			refetchSequenceData();
			setModal('null');
			toast.success(`succesfully requested`);
		} catch (error) {
			console.error('Error submitting the form:', error);
			toast.error(`Failed to submit: ${error.message}`);
		} finally {
			setLoading(false);
		}
	};

	const handleSequenceUpdate = async () => {
		try {
			await waitConformation('update');
		} catch (error) {
			return;
		}
		try {
			const instance = await getAxiosTokenInstance();
			let resp = await instance.post('/college/tc/updateTcSequenceNumbers', {
				type: 'tc',
				collegeId,
				userId: user.uid,
				lastAidedTcNumber: sequenceCounter?.lastAidedTcNumber + '',
				lastAidedTcBatchNumber: sequenceCounter?.lastAidedTcBatchNumber ? sequenceCounter?.lastAidedTcBatchNumber + '' : null,
				lastSelfTcNumber: sequenceCounter?.lastSelfTcNumber + '',
				lastSelfTcBatchNumber: sequenceCounter?.lastSelfTcBatchNumber ? sequenceCounter?.lastSelfTcBatchNumber + '' : null,
				lastGovtTcBatchNumber: sequenceCounter?.lastGovtTcBatchNumber ? sequenceCounter?.lastGovtTcBatchNumber + '' : null,
				lastGovtTcNumber: sequenceCounter?.lastGovtTcNumber ? sequenceCounter?.lastGovtTcNumber + '' : null,
			});
			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			} else {
				setModal(null);
				refetchSequenceData();
				toast.success('Sequence updated successfully');
			}
		} catch (error) {
			// message.error(error?.response?.data?.message || error?.message || 'API Error');
			toast.error('Error updating sequence');
		}
	};

	const handleFinalEdit = async () => {
		try {
			await waitConformation('update');
		} catch (error) {
			return;
		}
		setLoading(true);
		try {
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/tc/updateTcCcRequest', {
				collegeId,
				fullName: profile?.name,
				dob: profile?.dob,
				classId: profile?.classId,
				dateOfAdmission: profile?.dateOfAdmission,
				userId: profile?.userId || profile?._id,
				admisionNo: profile?.admisionNo,
				tcNumber: profile?.tcNumber,
				tcBatchNumber: profile?.tcBatchNumber,
				appliedOn: profile?.appliedOn,
				aprovedOn: profile?.aprovedOn,
				category: profile?.category,
				dateOfLeaving: profile?.dateOfLeaving,
				hallTicketNo: profile?.hallTicketNo,
				joinedSem: profile?.joinedSem,
				requestLetter: profile?.requestLetter,
				reasonForLeaving: profile?.reasonForLeaving,
				exam: profile?.exam,
				leaving: profile?.leavingSem,
				tcIssueDate: profile?.tcIssueDate,
				tcDate: profile?.aprovedOn,
				formData: {
					duesCleared: profile?.duesCleared,
					promotedToHigherClass: profile?.promotedToHigherClass,
					characterAndConduct: profile?.characterAndConduct,
				},
			});
			if (resp.data.statusCode !== 200) {
				toast.error('Error editing TC: API error');
			}
			toast.success('Edit successful.');
		} catch (error) {
			console.error('Error editing TC:', error);
			toast.error('Error editing TC');
		} finally {
			setLoading(false);
			setSection('Approved');
			setModal('null');
			setProfile({});
			refetchTcList();
			refetchSequenceData();
		}
	};

	// get Apis

	const handleOpenTcView = async (profile) => {
		setProfileLoading(true);
		try {
			const insance = await getAxiosTokenInstance();
			const { data } = await insance.get('/college/tc/getTcDetails', {
				params: {
					collegeId,
					userId: profile?._id,
					classId: profile?.classId,
				},
			});
			setProfile(data?.data);
			setStages('settings');
		} catch (error) {
			toast.error('Error opening editor');
		} finally {
			setProfileLoading(false);
		}
	};

	const handleOpenEditor = async (modalType, profile) => {
		setProfileLoading(true);
		try {
			const insance = await getAxiosTokenInstance();
			const { data } = await insance.get('/college/tc/getTcDetails', {
				params: {
					collegeId,
					userId: profile?._id,
					classId: profile?.classId,
				},
			});
			setProfile(data?.data);
			setModal(modalType);
		} catch (error) {
			toast.error('Error opening editor');
		} finally {
			setProfileLoading(false);
		}
	};

	// helper functions
	const handleReset = () => {
		setFilters({
			classId: '',
			batchId: '',
			admissionNoStart: '',
			admissionNoEnd: '',
			governBy: '',
			tcStartDate: '',
			tcEndDate: '',
			tcStartNo: '',
			tcEndNo: '',
			admnDateStartNo: '',
			admnDateEndNo: '',
			startDate: '',
			endingDate: '',
			printable: false,
			page: 1,
			limit: 25,
		});
		setAdvancedSearch('');
	};

	const handlleClose = () => {
		setModal('null');
		setProfile({});
	};

	const renderModal = () => {
		switch (modal) {
			case 'null':
				return null;
			case 'editBeforeApprove':
			case 'editTc':
				return (
					<Main width='90%' zIndex='1000'>
						<Header>
							<Instruction keyId={'TransferCertificate'} />
							<Button type='close' onClick={handlleClose}>
								close
							</Button>
						</Header>
						<Body>
							<h2 className='text-2xl font-semibold mb-6 text-center'>Edit TC Form</h2>
							<div className='grid grid-cols-1 md:grid-cols-2 gap-6 w-full'>
								<Input2 type='text' className='w-[90%]' fieldName='Admission No' state={profile} setState={setProfile} returnKey='admisionNo' />
								<Input2 type='text' className='w-[90%]' fieldName='Full Name' state={profile} setState={setProfile} returnKey='name' />
								<Input2 type='text' className='w-[90%]' fieldName='Register Number' state={profile} setState={setProfile} returnKey='hallTicketNo' />
								<Input2 type='drop' className='w-[90%]' fieldName='Class Name' state={profile} setState={setProfile} returnKey='classId' didntShowKey optionDisplay='className' optionKey='_id' options={allClassdata || []} />
								<Input2 type='drop' className='w-[90%]' fieldName='Category' state={profile} setState={setProfile} returnKey='category' options={catogorys} />
								<Input2 type='date' className='w-[90%]' fieldName='Date of Admission' state={profile} setState={setProfile} returnKey='dateOfAdmission' />
								<Input2 type='date' className='w-[90%]' fieldName='Date of Birth' state={profile} setState={setProfile} returnKey='dob' />
								<Input2 type='date' className='w-[90%]' fieldName='Date of Leaving' state={profile} setState={setProfile} returnKey='dateOfLeaving' />
								<Input2 type='date' className='w-[90%]' fieldName='Applied On' state={profile} setState={setProfile} returnKey='appliedOn' />
								{modal !== 'editBeforeApprove' && (
									<>
										<Input2 type='date' className='w-[90%]' fieldName='Approved On' state={profile} setState={setProfile} returnKey='aprovedOn' />
										<Input2 type='text' className='w-[90%]' fieldName='TC No' state={profile} setState={setProfile} returnKey='tcNumber' />
										<Input2 type='text' className='w-[90%]' fieldName='TC Batch No' state={profile} setState={setProfile} returnKey='tcBatchNumber' />
									</>
								)}
								<Input2 type='drop' className='w-[90%]' fieldName='Semester from Leaving' state={profile} setState={setProfile} returnKey='leavingSem' options={semesters} />
								<Input2 type='drop' className='w-[90%]' fieldName='Semester Joined' state={profile} setState={setProfile} returnKey='joinedSem' options={semesters} />
								<Input2 type='drop' className='w-[90%]' fieldName='Reason for Leaving' state={profile} setState={setProfile} returnKey='reasonForLeaving' options={reasons} />
								<Input2 type='drop' className='w-[90%]' fieldName='Last Exam ' state={profile} setState={setProfile} returnKey='exam' options={exams} />
								<Input2 type='drop' className='w-[90%]' fieldName='Dues Cleared' state={profile} setState={setProfile} returnKey='duesCleared' options={['yes', 'no']} />
								<Input2 type='drop' className='w-[90%]' fieldName='Promoted to Higher Class' state={profile} setState={setProfile} returnKey='promotedToHigherClass' options={['yes', 'no']} />
							</div>
							<Input2 type='textarea' className='w-[95%] relative' fieldName='Remarks (Optional)' state={profile} setState={setProfile} returnKey='requestLetter' />
							<div className='flex w-[100%] float-end align-baseline items-end justify-center h-40'>
								{modal == 'editBeforeApprove' ? (
									<Button width='200px' type='submit' onClick={oldTc}>
										Submit
									</Button>
								) : (
									<Button width='200px' type='submit' onClick={handleFinalEdit}>
										Save
									</Button>
								)}
							</div>
						</Body>
					</Main>
				);
			case 'counter':
				return (
					<Main width='40%' zIndex='1000'>
						<Header>
							<div></div>
							<Button type='close' onClick={() => setModal(null)}>
								close
							</Button>
							̰
						</Header>
						<Body>
							{!college?.institutionType ? (
								<div className='flex justify-center items-center h-full dark:text-white text-xl'>Please institutionType </div>
							) : (
								<div className='p-4 w-full'>
									{college?.institutionType?.includes('aided') && (
										<>
											<h6>Aided</h6>
											<Input2 width='100%' type='text' className='w-full' fieldName={`Last Tc Number: ${seqData?.lastAidedTcNumber ?? ''}`} returnKey='lastAidedTcNumber' state={sequenceCounter} setState={setSequenceCounter} />
											<Input2 width='100%' type='text' className='w-full' fieldName={`Last TC Batch Number: ${seqData?.lastAidedTcBatchNumber ?? ''}`} returnKey='lastAidedTcBatchNumber' state={sequenceCounter} setState={setSequenceCounter} />
										</>
									)}
									{college?.institutionType?.includes('self') && (
										<>
											<h6 className='mt-4'>Self</h6>
											<Input2 width='100%' type='text' className='w-full' fieldName={`Last Self Tc Number: ${seqData?.lastSelfTcNumber ?? ''}`} returnKey='lastSelfTcNumber' state={sequenceCounter} setState={setSequenceCounter} />
											<Input2 width='100%' type='text' className='w-full' fieldName={`Last Self TC Batch Number: ${seqData?.lastSelfTcBatchNumber ?? ''}`} returnKey='lastSelfTcBatchNumber' state={sequenceCounter} setState={setSequenceCounter} />
										</>
									)}
									{college?.institutionType?.includes('govt') && (
										<>
											<h6 className='mt-4'>Government</h6>
											<Input2 width='100%' type='text' className='w-full' fieldName={`Last Govt Tc Number: ${seqData?.lastGovtTcNumber ?? ''}`} returnKey='lastGovtTcNumber' state={sequenceCounter} setState={setSequenceCounter} />
											<Input2 width='100%' type='text' className='w-full' fieldName={`Last Govt TC Batch Number: ${seqData?.lastGovtTcBatchNumber ?? ''}`} returnKey='newBatchNo' state={sequenceCounter} lastGovtTcBatchNumber={setSequenceCounter} />
										</>
									)}
									<div className='flex justify-center'>
										<Button width='200px' type='submit' onClick={handleSequenceUpdate}>
											Submit
										</Button>
									</div>
								</div>
							)}
						</Body>
					</Main>
				);
			case 'instantTc':
				return (
					<Main width='90%' zIndex='1000'>
						<Header>
							<Button type='close' onClick={handlleClose}>
								close
							</Button>
						</Header>
						<Body>
							<h2 className='text-2xl font-semibold mb-6 text-center'>Instant TC Form</h2>
							<div className='grid grid-cols-1 md:grid-cols-2 gap-6 w-full'>
								<Input2 type='drop' className='w-[90%]' fieldName='Select Full Name' state={profile} setState={setProfile} didntShowKey optionDisplay='label' options={userList ? userList?.list.map((x) => ({ ...x, label: `${x.admisionNo} - ${x.name}` })) : []} />

								<Input2 type='text' className='w-[90%]' fieldName='Admission No' state={profile} setState={setProfile} returnKey='admisionNo' />
								<Input2 type='text' className='w-[90%]' fieldName='Hall Ticket No' state={profile} setState={setProfile} returnKey='hallTicketNo' />
								<Input2 type='drop' className='w-[90%]' fieldName='Category' state={profile} setState={setProfile} returnKey='category' options={catogorys} />
								<Input2 type='date' className='w-[90%]' fieldName='Date of Birth' state={profile} setState={setProfile} returnKey='dob' />
								<Input2 type='date' className='w-[90%]' fieldName='Date of Admission' state={profile} setState={setProfile} returnKey='dateOfAdmission' />
								<Input2 type='date' className='w-[90%]' fieldName='Date of Leaving' state={profile} setState={setProfile} returnKey='dateOfLeaving' />
								<Input2 type='drop' className='w-[90%]' fieldName='Semester from Leaving' state={profile} setState={setProfile} returnKey='leavingSem' options={semesters} />
								<Input2 type='drop' className='w-[90%]' fieldName='Reason for Leaving' state={profile} setState={setProfile} returnKey='reasonForLeaving' options={reasons} />
								<Input2 type='drop' className='w-[90%]' fieldName='Last Exam' state={profile} setState={setProfile} returnKey='exam' options={exams} />
								<Input2 type='drop' className='w-[90%]' fieldName='Dues Cleared' state={profile} setState={setProfile} returnKey='duesCleared' options={['yes', 'no']} />
							</div>
							<Input2 type='textarea' className='w-[95%] h-20' fieldName='Remarks (Optional)' state={profile} setState={setProfile} returnKey='requestLetter' />
							<div className='flex justify-center mt-24'>
								<Button width='200px' type='submit' onClick={requestNewTC}>
									Submit
								</Button>
							</div>
						</Body>
					</Main>
				);
			case 'oldTc':
				return (
					<Main width='90%' zIndex='1000'>
						<Header>
							<Button type='close' onClick={handlleClose}>
								close
							</Button>
						</Header>
						<Body>
							<h2 className='text-2xl font-semibold mb-6 text-center'>Instant TC Form</h2>
							<div className='grid grid-cols-1 md:grid-cols-2 gap-6 w-full'>
								<Input2 type='drop' className='w-[90%]' fieldName='Class Name' state={profile} setState={setProfile} didntShowKey optionDisplay='className' optionKey='classId' returnKey='classId' options={allClassdata || []} />
								<Input2 type='text' className='w-[90%]' fieldName='Full Name (as per SSLC)' state={profile} setState={setProfile} optionDisplay='name' optionKey='name' returnKey='name' />
								<Input2 type='number' className='w-[90%]' fieldName='Official Mobile Number' state={profile} setState={setProfile} optionDisplay='phoneNumber' optionKey='phoneNumber' returnKey='phoneNumber' />
								<Input2 type='drop' className='w-[90%]' fieldName='Category' state={profile} setState={setProfile} returnKey='category' options={catogorys} />
								<Input2 type='text' className='w-[90%]' fieldName='Admission Number' state={profile} setState={setProfile} optionDisplay='admisionNo' optionKey='admisionNo' returnKey='admisionNo' />
								<Input2 type='date' className='w-[90%]' fieldName='Date of Admission' state={profile} setState={setProfile} optionDisplay='dateOfAdmission' optionKey='dateOfAdmission' returnKey='dateOfAdmission' />
								<Input2 type='text' className='w-[90%]' fieldName='Register Number' state={profile} setState={setProfile} optionDisplay='hallTicketNo' optionKey='hallTicketNo' returnKey='hallTicketNo' />
								<Input2 type='date' className='w-[90%]' fieldName='Date of Birth' state={profile} setState={setProfile} optionDisplay='dob' optionKey='dob' returnKey='dob' />
								<Input2 type='date' className='w-[90%]' fieldName='Date of Leaving' state={profile} setState={setProfile} optionDisplay='dateOfLeaving' optionKey='dateOfLeaving' returnKey='dateOfLeaving' />
								<Input2 type='drop' className='w-[90%]' fieldName='Semester from Leaving' state={profile} setState={setProfile} returnKey='leavingSem' options={semesters} />
								<Input2 type='drop' className='w-[90%]' fieldName='Examination last Appeared' state={profile} setState={setProfile} returnKey='exam' options={exams} />
								<Input2 type='drop' className='w-[90%]' fieldName='Reason for Leaving' state={profile} setState={setProfile} returnKey='reasonForLeaving' options={reasons} />
							</div>
							<Input2 type='textarea' className='w-[95%]' fieldName='Remarks (Optional)' state={profile} setState={setProfile} returnKey='requestLetter' />
							<div className='flex justify-center mt-24'>
								<Button width='200px' type='submit' onClick={oldTc}>
									Submit
								</Button>
							</div>
						</Body>
					</Main>
				);
		}
	};

	const renderStage = () => {
		switch (stages) {
			case 'base':
				return (
					<Main title={'Transfer Certificate'} width='100vw' height='100vh' zIndex='900'>
						<div className='flex w-full h-full overflow-hidden'>
							<div className='w-[80%] h-full '>
								<Header>
									<div className='flex justify-between items-center bg-[#5c655c] rounded dark:bg-[#202020f5] w-[100%]'>
										<div className='flex flex-wrap gap-6 ml-4'>
											<div className='flex items-center space-x-2'>
												<input
													type='checkbox'
													id='tc-printed-list'
													checked={section === 'All'}
													onChange={() => {
														setSection('All');
													}}
													className='h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 transition duration-150'
												/>
												<label htmlFor='tc-printed-list' className='text-sm font-medium text-white'>
													All
												</label>
											</div>
											<div className='flex items-center space-x-2'>
												<input
													type='checkbox'
													id='tc-printed-list'
													checked={section === 'Printed'}
													onChange={() => {
														setSection('Printed');
													}}
													className='h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 transition duration-150'
												/>
												<label htmlFor='tc-printed-list' className='text-sm font-medium text-white'>
													Printed
												</label>
											</div>

											<div className='flex items-center space-x-2'>
												<input
													type='checkbox'
													id='tc-print-list'
													checked={section === 'Approved'}
													onChange={() => {
														setSection('Approved');
													}}
													className='h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 transition duration-150'
												/>
												<label htmlFor='tc-print-list' className='text-sm font-medium text-white'>
													Approved
												</label>
											</div>

											<div className='flex items-center space-x-2'>
												<input
													type='checkbox'
													id='tc-request'
													checked={section === 'Requested'}
													onChange={() => {
														setSection('Requested');
													}}
													className='h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 transition duration-150'
												/>
												<label htmlFor='tc-request' className='text-sm font-medium text-white'>
													Request
												</label>
											</div>
										</div>
										<Input2 width='600px' fieldName='Advanced Search' type='text' className='w-[40vw]' setState={setAdvancedSearch} state={advancedSearch} />
										<Button type='refresh' onClick={() => setFilters({ ...filters, refresh: !filters?.refresh })}>
											Search
										</Button>
									</div>
								</Header>

								<Body>
									{profileLoading && (
										<div className='flex justify-center items-center h-full'>
											<OLoading styles={{ width: 50, height: 50, size: 10 }} />
										</div>
									)}
									<div ref={ref} className='printable overflow-y-auto h-[90vh] w-[100%]'>
										{filters?.printable && (
											<div className='flex flex-row items-center justify-center p-4 border-b-2'>
												<div className='flex items-center'>
													<img className='w-16 h-16 mr-4 print:w-16 print:h-16' src={college?.logo} alt='College Logo' />
													<div>
														<h1 className='text-xl font-bold h-5'>{college?.collegeName}</h1>
														<p className='text-md font-semibold h-4'>{college?.accreditedGrade}</p>
														<p className='text-md font-semibold h-4'>{college?.address}</p>
													</div>
												</div>
											</div>
										)}

										<Table width={'100%'}>
											<Thead>
												<Tr>
													{[...(section === 'All' || section === 'Requested' ? columnsRequests || [] : columnsApprove || [])]
														.filter((x) => ((filters?.printable && x.keyName) === 'action' ? false : true))
														.map((field) => (
															<Th width={field.width} key={field.keyName} onClick={() => requestSort(field.keyName)} icon={getIcon(field.keyName)}>
																{field.title}
															</Th>
														))}
												</Tr>
											</Thead>

											<Tbody height={filters?.printable ? '69vh' : '80vh'}>
												{(loading || isTcListLoading) && <OLoading styles={{ width: 50, height: 50, size: 10 }} />}
												{tableItems?.map((item, index) => (
													<Tr key={index}>
														{(section === 'All' || section === 'Requested' ? columnsRequests : columnsApprove).map((field) => {
															let key = field.keyName;
															if (filters?.printable && key === 'action') {
																return null;
															}
															switch (key) {
																case 'slNo':
																	return (
																		<Td key={key} index={index} width={field.width}>
																			{index + 1}
																		</Td>
																	);
																case 'action':
																	const seq = item['governBody'] === 'Aided' ? seqData?.lastAidedTcNumber : item['governBody'] === 'Self' ? seqData?.lastSelfTcNumber : seqData?.lastGovtTcNumber;
																	const seqNo = seq ? parseInt(seq) + 1 : 1;
																	return (
																		<Td key={key} index={index} width={field.width}>
																			<div className='flex w-full justify-evenly'>
																				{item['tcIssueDate'] ? (
																					<>
																						<button
																							className='bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-2 rounded text-xs transition-colors duration-200 ease-in-out'
																							onClick={() => {
																								handleOpenEditor('editTc', item);
																							}}>
																							Edit
																						</button>
																						<Button
																							type='fetch'
																							onClick={(e) => {
																								e.stopPropagation();
																								handleOpenTcView(item);
																							}}>
																							Download
																						</Button>
																					</>
																				) : (
																					<>
																						<button
																							className='bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-2 rounded text-xs transition-colors duration-200 ease-in-out'
																							onClick={() => {
																								handleOpenEditor('editBeforeApprove', item);
																							}}>
																							Edit
																						</button>
																						<button
																							className='bg-green-500 hover:bg-green-600 text-white font-semibold py-1 px-2 rounded text-xs transition-colors duration-200 ease-in-out text-warp w-20'
																							onClick={(e) => {
																								aproveTcCc(item);
																								e.stopPropagation();
																							}}>
																							Approve | {seqNo}
																						</button>
																						<button
																							className='bg-red-500 hover:bg-red-600 text-white font-semibold py-1 px-2 rounded text-xs ml-1 transition-colors duration-200 ease-in-out'
																							onClick={async (e) => {
																								deleteTC(item);
																								e.stopPropagation();
																							}}>
																							Delete
																						</button>
																					</>
																				)}
																			</div>
																		</Td>
																	);
																default:
																	return (
																		<Td key={key} index={index} width={field.width}>
																			{field?.type == 'date' ? new Date(item[key])?.toLocaleDateString() : item[key]}
																		</Td>
																	);
															}
														})}
													</Tr>
												))}
											</Tbody>

											<Tfoot>
												<Tr>
													<Td colSpan={columnsRequests.length} className='flex justify-between'>
														<div className='flex items-center w-full justify-between'>
															<p className='text-sm font-medium text-gray-700 dark:text-white'>
																Total Records: {tcList?.totalCount}
																{tcList?.totalCount > 0 && (
																	<span>
																		{' '}
																		| Page {filters?.page} of {Math.ceil(tcList?.totalCount / filters?.limit)}
																	</span>
																)}
																{tcList?.totalCount > 1 && <span> | Showing {filters?.limit} records per page</span>}
															</p>
															<div className='flex items-center space-x-2 drak:bg-[#202020f5]'>
																<select
																	value={filters?.limit}
																	onChange={(e) => {
																		setFilters({ ...filters, limit: e.target.value });
																	}}
																	className='h-5 w-20 p-0 text-blue-600 px-auto  border-gray-300 rounded focus:ring-2 focus:ring-blue-500 transition duration-150'>
																	<option value='10'>10</option>
																	<option value='25'>25</option>
																	<option value='50'>50</option>
																	<option value='100'>100</option>
																	<option value='200'>200</option>
																	<option value='500'>500</option>
																	<option value='1000'>1000</option>
																	<option value='2000'>2000</option>
																</select>{' '}
																<label htmlFor='tc-request' className='text-sm font-medium dark:text-white text-gray-700'>
																	Limit
																</label>
															</div>
															<div className='flex  items-center space-x-2 drak:bg-[#202020f5]'>
																<select
																	value={filters?.page}
																	onChange={(e) => {
																		setFilters({ ...filters, page: e.target.value });
																	}}
																	className='h-5 p-0 w-10 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 transition duration-150'>
																	{Array.from({ length: Math.ceil(tcList?.totalCount / filters?.limit) }, (_, i) => (
																		<option key={i} value={i + 1}>
																			{i + 1}
																		</option>
																	))}
																</select>
																<label htmlFor='tc-request' className='text-sm font-medium dark:text-white text-gray-700'>
																	Page
																</label>
															</div>
														</div>
													</Td>
												</Tr>
											</Tfoot>
										</Table>
									</div>
								</Body>
							</div>

							<div className='w-[20vw] pe-1 h-full bg-[#5c655c] pl-2 rounded-lg overflow-y-scroll  dark:bg-[#202020f5]'>
								<header className='flex flex-col  flex-warp'>
									<div className='flex flex-wrap gap-4 w-full justify-between items-center my-4'>
										<div className='flex flex-wrap gap-1 flex-row-reverse w-full flex-grow'>
											<Button type='close' onClick={onClose}>
												Close
											</Button>
											{filters?.printable && (
												<Button type='print' width='4rem' tableRef={ref.current}>
													Print
												</Button>
											)}
											<Button type='excel' pdfId='profilePDF' tableRef={ref.current}>
												Excel
											</Button>
											<Button type='refresh' onClick={handleReset}>
												Reset
											</Button>
											<Button type={filters?.printable ? 'search' : 'update'} onClick={() => setFilters({ ...filters, printable: !filters?.printable })}>
												{filters?.printable ? 'Hide Print Mode' : 'Show Print Mode'}
											</Button>
											<Button type='refresh' onClick={() => setFilters({ ...filters, refresh: !filters?.refresh })}>
												Refresh
											</Button>
											<Instruction keyId={'TransferCertificate'} />
										</div>
									</div>
									<div className='flex justify-between w-full my-2 flex-warp'>
										<Button
											type='edit'
											width='1/2'
											onClick={() => {
												setModal('oldTc');
												setProfile({});
											}}>
											Old TC Form
										</Button>
										<Button
											type='submit'
											onClick={() => {
												setProfile({});
												setModal('instantTc');
											}}>
											New TC Form
										</Button>
									</div>

									<div className='flex justify-between w-full gap-2  flex-warp'>
										<button type='button' onClick={() => setModal('counter')} className='flex w-[50%] text-white flex-between items-center h-12 mt-[10px] bg-green-900 border border-green-800 hover:bg-green-700 hover:border-gray-700  font-semibold py-2 px-3 ml-1 gap-2 rounded-lg shadow-lg shadow-gray-900 hover:shadow-3xl transition duration-300 ease-in-out transform hover:scale-105'>
											<div>Count </div>
											<FaCog className=' text-gray-100' size={18} />
										</button>

										<button
											type='button'
											onClick={(e) => {
												handleOpenTcView(tableItems[0]);
												e.stopPropagation();
											}}
											className='flex flex-between items-center w-[50%] h-12 mt-[10px] bg-gray-300 border border-gray-400 hover:bg-gray-400 hover:border-gray-900  font-semibold py-2 px-3 ml-1 rounded-lg shadow-lg shadow-gray-900 hover:shadow-3xl transition duration-300 ease-in-out gap-2 transform hover:scale-105 disabled:bg-gray-100'>
											<div>Template </div>
											<FaCog className=' text-gray-700' size={18} />
										</button>
									</div>
									{college?.institutionType?.length !== 0 && (
										<div className='flex flex-col w-72 gap-y-1'>
											<Input2 fieldName='Govern By' state={filters} setState={setFilters} textCase='capitalize' returnKey='governBy' options={[...(college?.institutionType || []), 'ALL']} type='drop' className='w-[18vw]' />
										</div>
									)}
									<div className='flex flex-col w-72 gap-y-1'>
										<Input2 fieldName='Filter by Batch' state={filters} returnKey='batchId' didntShowKey setState={setFilters} options={batches} type='drop' className='w-[18vw]' />
										{classDataByBatch?.length > 0 && <Input2 fieldName='Filter by Course' typable state={filters} setState={setFilters} didntShowKey optionDisplay='shortName' optionKey='_id' returnKey='classId' options={classDataByBatch || []} type='drop' className='w-[18vw]' />}
									</div>
									<div className='w-[100%] flex flex-col gap-y-2 pe-1'>
										<div className='bg-[#4d5358] p-2 rounded-md accordion w-[100%] cursor-pointer '>
											<p className='text-white text-center font-bold cursor-pointer'>Filter by Admission Date</p>
											<div className={`overflow-hidden transition-[max-height] duration-300 ease-in-out max-h-96`}>
												<Input2 fieldName='Start Date *' returnKey='admnDateStartNo' state={filters} setState={setFilters} type='date' className='w-[96%]' />
												<Input2 fieldName='End Date *' returnKey='admnDateEndNo' state={filters} setState={setFilters} type='date' className='w-[96%]' />
											</div>
										</div>
										<div className='bg-[#40515f] p-2 rounded-md accordion w-[100%] cursor-pointer'>
											<p className='text-white text-center font-bold cursor-pointer'>Filter by Admission No</p>
											<div className={`overflow-hidden transition-[max-height] duration-300 ease-in-out max-h-96`}>
												<Input2 fieldName='Start No *' returnKey='admissionNoStart' state={filters} setState={setFilters} type='number' className='w-[96%]' />
												<Input2 fieldName='End No *' returnKey='admissionNoEnd' state={filters} setState={setFilters} type='number' className='w-[96%]' />
											</div>
										</div>
										{section !== 'Requested' && (
											<>
												<div className='bg-[#4d5358] p-2 rounded-md accordion w-[100%] cursor-pointer'>
													<p className='  text-white text-center font-bold cursor-pointer hover:scale-1.5 rounded'>Filter by TC Date</p>
													<div className={`overflow-hidden transition-[max-height] duration-300  ease-in-out max-h-96`}>
														<Input2 fieldName='Start Date *' returnKey='tcStartDate' state={filters} setState={setFilters} type='date' className='w-[96%]' />
														<Input2 fieldName='End Date *' returnKey='tcEndDate' state={filters} setState={setFilters} type='date' className='w-[96%]' />
													</div>
												</div>
												<div className='bg-[#40515f] p-2 rounded-md accordion w-[100%] cursor-pointer'>
													<p className='text-white text-center font-bold cursor-pointer'>Filter by TC No</p>
													<div className={`overflow-hidden transition-[max-height] duration-300 ease-in-out max-h-96`}>
														<Input2 fieldName='Start Tc No *' returnKey='tcStartNo' state={filters} setState={setFilters} type='number' className='w-[96%]' />
														<Input2 fieldName='End Tc No *' returnKey='tcEndNo' state={filters} setState={setFilters} type='number' className='w-[96%]' />
													</div>
												</div>
											</>
										)}
									</div>
								</header>
							</div>
						</div>
					</Main>
				);
			case 'settings':
				return <TCView2 profile={profile} refetchList={refetchTcList} setProfile={setProfile} setTcView={() => setStages('base')} userId={profile?._id} />;
		}
	};

	const waitConformation = (type) => {
		return new Promise((resolve, reject) => {
			setConfirmation({
				type,
				resolve: () => {
					resolve(true);
					setConfirmation({});
				},
				reject: () => {
					reject(false);
					setConfirmation({});
				},
			});
		});
	};

	const confirmationConfig = {
		delete: {
			title: 'Delete Confirmation',
			message: 'Are you sure you want to delete this item?',
			confirmText: 'Delete',
		},
		reset: {
			title: 'Reset Confirmation',
			message: 'Are you sure you want to reset this item?',
			confirmText: 'Reset',
		},
		save: {
			title: 'Save Confirmation',
			message: 'Are you sure you want to save this item?',
			confirmText: 'Save',
		},
		update: {
			title: 'Update Confirmation',
			message: 'Are you sure you want to update this item?',
			confirmText: 'Update',
		},
		approve: {
			title: 'Approve Confirmation',
			message: 'Are you sure you want to approve this item?',
			confirmText: 'Approve',
		},
		reject: {
			title: 'Reject Confirmation',
			message: 'Are you sure you want to reject this item?',
			confirmText: 'Reject',
		},
		print: {
			title: 'Print Confirmation',
			message: 'Are you sure you want to print this item?',
			confirmText: 'Print',
		},
		add: {
			title: 'Add Confirmation',
			message: 'Are you sure you want to add this item?',
			confirmText: 'Add',
		},
		submit: {
			title: 'Submit Confirmation',
			message: 'Are you sure you want to submit this item?',
			confirmText: 'Submit',
		},
	};

	const renderConfirmation = () => {
		if (!confirmation?.type) return null;

		const config = confirmationConfig[confirmation.type];
		if (!config) return null;

		return (
			<Main title={config.title} zIndex='2000'>
				<div className='flex flex-col items-center justify-center p-10'>
					<h1 className='text-2xl font-semibold mb-4'>{config.message}</h1>
					<div className='flex gap-4'>
						<Button color='red' onClick={() => confirmation.resolve()}>
							{config.confirmText}
						</Button>
						<Button color='green' onClick={() => confirmation.reject()}>
							Cancel
						</Button>
					</div>
				</div>
			</Main>
		);
	};

	return (
		<>
			<Toaster />
			{renderStage()}
			{renderModal()}
			{renderConfirmation()}
		</>
	);
};
